export const attachTooltip = "F7a";
export const insertTooltip = "G7a";
export default {attachTooltip,insertTooltip};